export default __webpack_public_path__ + "static/media/logo-2.312d90f5.png";